import React from 'react'
import PropTypes from 'prop-types'
import {get} from 'lodash'
import className from 'classnames'
import Head from 'next/head'
import Link from 'next/link'
import dynamic from 'next/dynamic'

import {t, axios, stripTags} from '@lib/helpers'

const Meta = dynamic(() => import('@components/Meta'))
const Custom404 = dynamic(() => import('@components/Custom404'))

const CasesShow = ({c}) => {
  if (get(c, '_status')) {
    return <Custom404 />
  }

  return (
    <React.Fragment>
      <Meta
        title={`${t('pages.cases.title')} – ${
          get(c, 'meta_title') || get(c, 'title')
        } – ${t('layout.title')}`}
        description={get(c, 'meta_description') || stripTags(get(c, 'summary'))}
      />

      <div className='CasesShow'>
        <div className='ServicesShow__hero'>
          <div className='ServicesShow__hero__wrapper-outer'>
            <div className='container'>
              <img
                className='ServicesShow__hero__img'
                alt='ServicesShow__hero__img'
                src={get(c, 'image_1.url')}
              />

              <div className='ServicesShow__hero__wrapper'>
                {false && (
                  <small className='ServicesShow__hero__small'>Case 01</small>
                )}

                <h2 className='ServicesShow__hero__h2 ServicesShow__hero__h2--green'>
                  {get(c, 'title')}
                </h2>

                <div
                  className='ServicesShow__hero__p'
                  dangerouslySetInnerHTML={{__html: get(c, 'summary')}}
                ></div>

                <div className='Buttons'>
                  <Link href='/cases'>
                    <a className='ServicesShow__hero__a'>
                      Back to case studies
                    </a>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='BodySpace BodySpace--no-top'>
          <div className='ServicesShow__dual ServicesShow__dual--green'>
            <div className='ServicesShow__dual__wrapper'>
              <div className='container'>
                {[
                  {
                    h3: 'Business Challenges',
                    ps: get(c, 'businesses_challenges'),
                  },
                  {
                    h3: 'Solution',
                    ps: get(c, 'solution'),
                  },
                ].map((x, i) => (
                  <div className='ServicesShow__dual__box' key={i}>
                    <h3 className='ServicesShow__dual__box__h3'>
                      {get(x, 'h3')}
                    </h3>

                    <div
                      className='ServicesShow__dual__box__p'
                      dangerouslySetInnerHTML={{__html: get(x, 'ps')}}
                    ></div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div
            className='ServicesShow__end-result'
            style={{
              padding: 'calc(var(--global-space) * 7.5) 0',
            }}
          >
            <div className='container'>
              <div className='ServicesShow__end-result__box'>
                <h3 className='ServicesShow__end-result__box__h3'>
                  Deliverables
                </h3>

                <div
                  className='ServicesShow__deliverables__dl ServicesShow__deliverables__dl--white'
                  dangerouslySetInnerHTML={{__html: get(c, 'deliverables')}}
                ></div>
              </div>
            </div>
          </div>

          <div className='CasesShow__expected-outcome'>
            <div className='container'>
              <h3 className='CasesShow__expected-outcome__h3'>
                Expected <br />
                Outcome
              </h3>

              <div
                className='CasesShow__expected-outcome__p'
                dangerouslySetInnerHTML={{__html: get(c, 'expected_outcome')}}
              ></div>

              {false && (
                <React.Fragment>
                  <div className='CasesShow__expected-outcome__box'>
                    <div className='CasesShow__expected-outcome__box__right'>
                      <p className='CasesShow__expected-outcome__box__right__name'>
                        Mary Jane
                      </p>

                      <p className='CasesShow__expected-outcome__box__right__position'>
                        Digital Marketing Manager
                      </p>
                    </div>

                    <h4 className='CasesShow__expected-outcome__box__h4'>
                      Testimonial
                    </h4>

                    <p className='CasesShow__expected-outcome__box__p'>
                      “From the very first meeting with ADSP, I knew they would
                      be a perfect partner to work with. Their knowledge and
                      flexibility in the approach allowed them to complement our
                      cross-functional approach to digital product development.
                      Over the last year we've collaborated on different aspects
                      of multiple products, and their skills in data science and
                      engineering helped us and our products reach the next
                      level.”
                    </p>
                  </div>
                </React.Fragment>
              )}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

CasesShow.propTypes = {}

export const getServerSideProps = async (ctx) => {
  let c

  try {
    c = await axios.get(`/case_studies/${get(ctx, 'query.id')}`)
  } catch (e) {
    const _status = get(e, 'response.status')

    if (ctx.res) {
      ctx.res.statusCode = _status
    }

    return {
      props: {
        c: {
          _status,
        },
      },
    }
  }

  return {
    props: {
      c: get(c, 'data.data'),
      query: get(ctx, 'query'),
    },
  }
}

export default CasesShow
